import React from 'react';
import styled from 'styled-components';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { IconContext } from 'react-icons';
import { Palette } from 'core/config';

interface Props 
{
    type      : 'button' | 'submit' | 'reset';
    title     : string;
    arrowCss? : string;
    css?      : string;
    disabled? : boolean;
    onClick?  : () => void;
}

export const Button : React.FunctionComponent<Props> = ({ 
    type, 
    onClick, 
    title, 
    disabled, 
    css, 
    arrowCss 
}) =>
{
    return (
        <ButtonContainer 
            type={type} 
            onClick={onClick} 
            disabled={disabled} 
            css={css}
        >
            {title}
            {arrowCss ? (
                <ArrowContainer arrowCss={arrowCss}>
                    <IconContext.Provider value={{ size: '1.25em' }}>
                        <Arrow />
                    </IconContext.Provider>
                </ArrowContainer>
            ) : (
                <IconContext.Provider value={{ size: '1.25em' }}>
                    <Arrow />
                </IconContext.Provider>
            )}
        </ButtonContainer>
    );
};

type StyledProps = {
    disabled? : boolean;
    arrowCss? : string;
    css?      : string;
};

const ButtonContainer = styled.button<StyledProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 301px;
    height: 43px;
    margin-left: -1px;
    border-radius: 11px;
    box-shadow: none;
    border: none;
    background-color: ${Palette.ORANGE};
    font: normal normal normal 14px 'SofiaPro-Regular';
    text-transform: uppercase;
    text-decoration: none;
    color: ${Palette.EGGSHELL_WHITE};
    margin-top: 17px;

    ${props => props.disabled ? (
        `
        cursor: not-allowed;
        opacity: 0.25;
        `
    ) : (
        `
        cursor: pointer;
        :hover {
            background-color: ${Palette.LIGHT_ORANGE};
        }
        `
    )}

    @media only screen and (min-width: 1300px) {
        margin-left: 0;
    }

    ${props => props.css && props.css}
`;

const Arrow = styled(IoIosArrowRoundForward)<StyledProps>`
    padding-left: 10px;

    ${props => props.arrowCss && props.arrowCss}
`;

const ArrowContainer = styled.span<StyledProps>`
    ${props => props.arrowCss && props.arrowCss}
`;